<template>
  <div class="bookshelf">
    <div v-for="book in bookList" :key="book.id" class="bookItem" @click="seeDetail(book)">
      <BookItem :href="book.href" :src="book.coverUrl" />
      <div class="md5">{{ book.title }}</div>
      <div class="md5 read-count" v-if="book.readByUserCount">浏览人数：{{ book.readByUserCount }}</div>
    </div> 
  </div>
</template>


<script>
export default {
  props: {
    bookList: Array,
  },
  methods: {
    seeDetail(book) {
      const currentPath = this.$route.path;
      if (currentPath.startsWith('/book/')) {
        console.log('md5', book.md5)
        this.$router.push({
          path: '/book/'+ book.md5,
        });
        this.$emit('redirectBook')
      } else {
        // 否则，执行正常的 push 操作
        this.$router.push({
          path: '/book/'+ book.md5,
        });
      }
      
    }
  }
};
</script>

<style lang="less" scoped>
.bookshelf {
  display: flex;
  gap: 30px;
  /* background-color: rgb(239, 239, 239); */
  border: 1px solid rgb(203, 203, 203);
  border-radius: 12px;
  padding: 45px 10px 25px 20px;
  width: 100%;
  margin: auto;
  overflow-x: scroll;
  .bookItem {
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: 100px;
  }
  .md5 {
    text-align: center;
    letter-spacing: 1px;
    color: var(--head-line);
    font-weight: 400;
    font-size: 12px;
    max-height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.read-count {
  color: rgb(187, 187, 187);
}
</style>